import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import {
  LANDING_1_WHY_ICONS,
  LANDING_1_WHY_ITEMS,
} from "../../landing-1.section-data";

@Component({
  selector: "app-landing-1-why",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule],
  templateUrl: "./landing-1-why.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1WhyComponent {
  readonly whyItems = LANDING_1_WHY_ITEMS;
  readonly whyIcons = LANDING_1_WHY_ICONS;
}
